import { requiredActionsTypes } from "../types";

const initState = {
  requiredActionsResolving: false,
  requiredActionsLoading: false,
  requiredActions: [],
};

export function requiredActions(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case requiredActionsTypes.GET_REQUIRED_ACTIONS_REQUEST: {
      return { ...state, requiredActionsLoading: true };
    }
    case requiredActionsTypes.GET_REQUIRED_ACTIONS_SUCCESS: {
      return { ...state, requiredActionsLoading: false, requiredActions: payload };
    }
    case requiredActionsTypes.GET_REQUIRED_ACTIONS_FAILURE: {
      return { ...state, requiredActionsLoading: false, requiredActions: [] };
    }

    case requiredActionsTypes.RESOLVE_REQUIRED_ACTION_REQUEST: {
      return { ...state, requiredActionsResolving: true };
    }
    case requiredActionsTypes.RESOLVE_REQUIRED_ACTION_SUCCESS: {
      return { ...state, requiredActionsResolving: false };
    }
    case requiredActionsTypes.RESOLVE_REQUIRED_ACTION_FAILURE: {
      return { ...state, requiredActionsResolving: false };
    }

    default:
      return state;
  }
}
